import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/store/auth'
import { hasPermission } from '#shared/utils/permissions'

// Gating de UI (cosmético — a barreira real é o servidor):
//   can('charges')      → true se tem a permissão OU é admin
//   canAny(OPERATIONAL) → grupos de shared/utils/permissions.ts
export const useCan = () => {
    const { god } = storeToRefs(useAuthStore())

    const canAny = (permissions: string[]) => hasPermission(god.value?.permissions, permissions)
    const can = (permission: string) => canAny([permission])

    return { can, canAny }
}
